/* @generated from adl module ferovinum.app.nodeapi */

import * as ADL from './../../runtime/adl';
import * as common_http from './../../common/http';
import * as ferovinum_app_api from './api';

export interface ApiRequests {
  getOrgDetails: common_http.HttpPost<ferovinum_app_api.OrganisationReq, GetOrgDetailsResp>;
}

export function makeApiRequests(
  input: {
    getOrgDetails?: common_http.HttpPost<ferovinum_app_api.OrganisationReq, GetOrgDetailsResp>,
  }
): ApiRequests {
  return {
    getOrgDetails: input.getOrgDetails === undefined ? {path : "/org-details", security : {kind : "tokenWithRole", value : "user"}, rateLimit : null, reqType : ferovinum_app_api.texprOrganisationReq(), respType : texprGetOrgDetailsResp()} : input.getOrgDetails,
  };
}

const ApiRequests_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.nodeapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"getOrgDetails","default":{"kind":"just","value":{"path":"/org-details","security":{"tokenWithRole":"user"}}},"name":"getOrgDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.api","name":"OrganisationReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.nodeapi","name":"GetOrgDetailsResp"}},"parameters":[]}]}}]}},"name":"ApiRequests","version":{"kind":"nothing"}}};

export const snApiRequests: ADL.ScopedName = {moduleName:"ferovinum.app.nodeapi", name:"ApiRequests"};

export function texprApiRequests(): ADL.ATypeExpr<ApiRequests> {
  return {value : {typeRef : {kind: "reference", value : snApiRequests}, parameters : []}};
}

export interface GetOrgDetailsResp {
  orgName: string;
}

export function makeGetOrgDetailsResp(
  input: {
    orgName: string,
  }
): GetOrgDetailsResp {
  return {
    orgName: input.orgName,
  };
}

const GetOrgDetailsResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.nodeapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"orgName","default":{"kind":"nothing"},"name":"orgName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"GetOrgDetailsResp","version":{"kind":"nothing"}}};

export const snGetOrgDetailsResp: ADL.ScopedName = {moduleName:"ferovinum.app.nodeapi", name:"GetOrgDetailsResp"};

export function texprGetOrgDetailsResp(): ADL.ATypeExpr<GetOrgDetailsResp> {
  return {value : {typeRef : {kind: "reference", value : snGetOrgDetailsResp}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.nodeapi.ApiRequests" : ApiRequests_AST,
  "ferovinum.app.nodeapi.GetOrgDetailsResp" : GetOrgDetailsResp_AST
};
